import { Checkbox, TableCell, TableRow, IconButton } from "@mui/material";
import { strDateFormat } from "../utils/functions";
import { useNavigate } from "react-router-dom";
import ProcessableAlert from "./ProcessableAlert.jsx";
import { get_order_status_label } from "../helpers/enums.js";

function ForRoutingRow(props) {
  const {
    request,
    columns,
    color,
    isSelected,
    selected,
    dateFilter,
    orderTypes,
  } = props;
  let navigate = useNavigate();

  return (
    <>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ backgroundColor: color }}
      >
        {/* <TableCell padding="checkbox" className="row-checkbox error-padding">
          <div className="container-error-checkbox">
            <Checkbox
              checked={isItemSelected}
              onClick={(event) => props.handleClick(event, request)}
            />
          </div>
        </TableCell> */}

        {columns.map((column, index) => {
          return (
            <TableCell
              component="th"
              scope="row"
              key={`${column.columnName}-${index}`}
            >
              {column.dbName === "label" ? (
                request.label && request.label.trim() !== "" ? (
                  <Checkbox checked={true} />
                ) : (
                  "Sin etiqueta"
                )
              ) : // Other conditions remain unchanged
              column.dbName === "id_goex" ? (
                request.id
              ) : column.dbName === "reference_id" ? (
                request.reference_id
              ) : column.dbName === "seller_company_social_reason" ? (
                request.seller?.company.social_reason
              ) : column.dbName === "recipient" ? (
                request.recipient
              ) : column.dbName === "address" ? (
                request.delivery?.shipping_address?.street ? (
                  request.delivery.shipping_address.street +
                  " " +
                  request.delivery.shipping_address.street_number
                ) : null
              ) : column.dbName === "comuna_name" ? (
                request.delivery?.shipping_address?.commune
              ) : column.dbName === "withdrawal_date" ? (
                request.withdrawal?.withdrawal_date &&
                strDateFormat(new Date(request.withdrawal.withdrawal_date))
              ) : column.dbName === "order_type" ? (
                orderTypes[request.type]
              ) : column.dbName === "status" ? (
                get_order_status_label(request.mixed_status, request.type)
              ) : column.dbName === "delivery_courier_name" ? (
                request.delivery?.shipping_zone?.courier
              ) : column.dbName === "creation_date" ? (
                request.created_at &&
                strDateFormat(new Date(request.created_at))
              ) : column.dbName === "existences_quantity" ? (
                request.total_products
              ) : column.dbName === "fulfillment_status" ? (
                <ProcessableAlert order={request} />
              ) : column.dbName === "process" ? (
                <IconButton
                  onClick={() => navigate(`/home/process-order/${request.id}`)}
                >
                  {" "}
                  <i className="material-icons">add</i>
                </IconButton>
              ) : column.dbName === "details" ? (
                <IconButton
                  onClick={() => navigate(`/home/order-details/${request.id}`)}
                >
                  {" "}
                  <i className="material-icons">add</i>
                </IconButton>
              ) : (
                "SIN INFORMACIÓN"
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}

export default ForRoutingRow;
